import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@virtual-care/shadcn';

import { useLanguage } from './use-language.ts';

export function LanguageSwitcher(props: {
  variant?: 'desktop' | 'mobile';
  className?: string;
}) {
  const variant = props.variant ?? 'desktop';
  const { t } = useTranslation();
  const { language, toggle } = useLanguage();
  const target = language === 'ar' ? 'en' : 'ar';
  const targetLabel =
    target === 'ar' ? t('shell.language.arabic') : t('shell.language.english');

  const isDesktop = variant === 'desktop';

  return (
    <button
      type="button"
      onClick={() => void toggle()}
      aria-label={`${t('shell.language.switchTo')} ${targetLabel}`}
      className={cn(
        'flex items-center justify-center rounded-lg text-white transition-colors hover:bg-emerald-700',
        isDesktop ? 'h-12 w-12 flex-col' : 'min-h-6 flex-1 flex-col py-2',
        props.className,
      )}
    >
      <Languages className="h-5 w-5" />
      <span className="mt-0.5 text-[10px] leading-none font-medium">
        {target.toUpperCase()}
      </span>
    </button>
  );
}
